import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ProtectedRoute } from "./components/common/ProtectedRoute";
import Chat from "./views/chat/chat";
import Login from "./views/login/login";
import ConfirmEmail from "./views/register/confirmEmail";
import Register from "./views/register/register";
import SelectPlan from "./views/SelectPlan/SelectPlan";
import LayoutNavbar from "./components/layout/LayoutNavbar";
import { SelectedFileProvider } from "./context/SelectedFileContext";
import { MenuProvider } from "./context/MenuContext";
import ChangePassword from "./views/changePassword/ChangePassword";

const AppRouter = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <SelectedFileProvider>
        <MenuProvider>
          <Routes>
            {/* Ruta de login fuera del layout */}
            <Route path="/" element={<Login />} />
            {/* Rutas dentro del layout */}
            <Route path="/" element={<LayoutNavbar />}>
              <Route
                path="/chat"
                element={
                  <ProtectedRoute>
                    <Chat />
                  </ProtectedRoute>
                }
              />
              <Route path="/select-plan" element={<SelectPlan />} />
              <Route path="/confirm-email" element={<ConfirmEmail />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/register" element={<Register />} />
            </Route>
          </Routes>
        </MenuProvider>
      </SelectedFileProvider>
    </Router>
  );
};

export default AppRouter;
